/* 

  How it works:



*/


// Toast creation and management functions
function createToast(templateId) {
  const template = document.getElementById(templateId);
  if (!template) return;

  const toast = document.createElement('div');
  toast.className = 'fomo-toast';
  
  // Create progress bar
  const progressBar = document.createElement('div');
  progressBar.className = 'fomo-progress';
  
  toast.innerHTML = template.innerHTML;
  toast.appendChild(progressBar);

  return toast;
}

// Global function to add a toast
function addToast(toast) {
  const container = document.getElementById('toast-container');
  if (!container || !toast) return;

  container.appendChild(toast);
  
  // Start progress bar animation
  requestAnimationFrame(() => {
    toast.querySelector('.fomo-progress').classList.add('animate');
  });

  setTimeout(() => {
    toast.classList.add('hiding');
    setTimeout(() => {
      if (toast.parentNode) {
        container.removeChild(toast);
      }
    }, 300);
  }, 5000); // test with 290000, original=5000 (5 sec, like the CSS animation length)
}

// Global function to show toast
function showToast(templateId) {
  const toast = createToast(templateId);
  if (toast) {
    addToast(toast);
  }
}

async function getFOMOdata ( ) {

  const startTime = performance.now();
  const urlParams = new URLSearchParams({
    request: 'get',
    type: 'fomo'
  });

  try {
    const response = await fetch(`${GOOGLE_APPS_SCRIPT_URL}?${urlParams}`, {
      method: 'GET'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    data.requestTime = performance.now() - startTime;
    return data;
  } catch (error) {
    console.error('Get FOMO data error:', error);
    throw new Error(`Failed to FOMO data: ${error.message}\nRequest URL: ${GOOGLE_APPS_SCRIPT_URL}?${urlParams}`);
  }

}

async function fomo_loadImage ( image_src ) {
  const response = await fetch( image_src )
  if( !response.ok ) throw new Error(`HTTP error! status: ${response.status}`);
  const blob = await response.blob()
  const imageURL = URL.createObjectURL(blob);
  return imageURL
}

function fomo_setupToats ( interactions ) {

  let interaction_index = 0
  const viewed_interactions = []
  const viewed_interactions_products = []
  const max_interactions = 50

  function createNewToast () {

    if ( interaction_index == max_interactions )
      clearInterval(toast_interv)

    // Skip interaction if already viewed
    if ( viewed_interactions.includes(interactions[interaction_index]) )
    {
      interaction_index ++
    }

    // // Skip interaction if product has been seen more than twice
    // if ( viewed_interactions_products.includes( interactions[interaction_index].id ) )
    // {
    //   times_added = 0
    //   viewed_interactions_products.forEach( inter => {
    //     if (inter = interactions[interaction_index].id )
    //       times_added++
    //   })

    //   if ( times_added >= 2 )
    //   {
    //     interactions = interactions.filter( prod => prod.id != interactions[interaction_index].id )
    //   }
    // }

    // Make sure to not grab a null value
    if ( ! interactions[interaction_index] ) interaction_index = 0

    let interaction = interactions[interaction_index]

    /*
      {
        // Product ID
        id: 8630642770134,
        details:
          [
            // Location
            "Miami, Florida",

            // v: variant, h: handle
            {v: 45839183904982, h: 'thats-dope-american-slang-heather-cotton-short-sleeve-mens-tee'},

            // Visited Time
            "10:28"
          ]
      }

    */

    const shopifyAPI_GetProduct = window.Shopify.routes.root + `products/${interaction.details[1].h}.js`

    fetch( shopifyAPI_GetProduct )
      .then( response => response.json() )
      .then( product => {

        //console.dir(product)

        const title = product.title

        // Hours and min with 2 digits
        // const hours = interaction.date.getHours().toString().padStart(2, '0')
        // const min = interaction.date.getMinutes().toString().padStart(2, '0')
        // const viewed_time = `${hours}:${min}`;

        const viewed_locationDisplayed = interaction.details[0]

        // Get toast container
        let toast = document.getElementById('purchase-message')

        // Set URL
        toast.setAttribute('data-url', location.origin + product.url );

        // Set Product Title
        toast.querySelector('.fomo-title').textContent = title

        // Set Time - update UI
        toast.querySelector('.fomo-time').textContent = interaction.details[2]

        // Set Message
        if ( viewed_locationDisplayed.includes('Unknown') ) {
          locationTextContent = `Someone viewed this product in the last 24hrs`
        }
        else {
          locationTextContent = `Someone from ${viewed_locationDisplayed} showed interest in the last 24hrs`
        }
        toast.querySelector('.fomo-message').textContent = locationTextContent

        // Set Image (fetch image first)
        // fomo_loadImage( product.featured_image )
        //   .then( image_url => {
        //     toast.querySelector('.fomo-product-image').src = image_url

        //     // display toast
        //     showToast('purchase-message')
        //   })

        // Set Slideshow
        max_image_counter = 1
        const max_images = 3
        const media_src = []
        fomo_loadImage( product.media[0].src )
                                      .then( first_image_url => { 
                                        const sliderTrack = '.fomo-image-container.carouselle .slideshow_img_slideshow-track'; 
                                        const selectorSelectImage = `${sliderTrack} div:nth-child(1) img`; 
                                        toast.querySelector(selectorSelectImage).src = first_image_url; return sliderTrack })
                                      .then( sliderTrack => {
                                        fomo_loadImage( product.media[1].src )
                                          .then( second_image_url => {
                                            const selectorSelectImage = `${sliderTrack} div:nth-child(2) img`
                                            toast.querySelector(selectorSelectImage).src = second_image_url
                                            return sliderTrack
                                          })
                                          .then( sliderTrack => {
                                            fomo_loadImage( product.media[2].src )
                                              .then( third_image_url => {
                                                const selectorSelectImage = `${sliderTrack} div:nth-child(3) img`
                                                toast.querySelector(selectorSelectImage).src = third_image_url
                                                return "ok"
                                              })
                                              .then( 
                                                ok => {
                                                  // display toast 
                                                  showToast('purchase-message') 
                                                }
                                              )
                                          })
                                      })

        

      });

    viewed_interactions.push(interaction)
    viewed_interactions_products.push(interaction.id)
    interaction_index++
  }

  //createNewToast();
  const toast_interv = setInterval(createNewToast, 40000);  // 10000=10 sec, 30000=30s, 60000=1min, 300000 =5 min, 
}

function initToasts () {

  // Make the toast clickable
  document.getElementById('toast-container').addEventListener('click', 
    e => {
      const toast_url = document.getElementById('purchase-message').getAttribute('data-url');
      if ( toast_url )
        location.href = toast_url
    }
  )

  getFOMOdata()
    .then(
      _ => {

        /*
        {
          // Product ID
          id: 8630642770134,
          details:
            [
              // Location
              "Miami, Florida",

              // v: variant, h: handle
              {v: 45839183904982, h: 'thats-dope-american-slang-heather-cotton-short-sleeve-mens-tee'},

              // Visited Time
              "10:28"
            ]
        */
        console.log("Original FOMO request",_.data)
        const interactions = _.data.map( inter => {
          const inter_date = new Date( inter.timestamp );
          const inter_time_hours = inter_date.getHours().toString().padStart(2, '0')
          const inter_time_min = inter_date.getMinutes().toString().padStart(2, '0')
          return {
              id:inter.product.id,
              env: inter.env,
              details: [
                  `${inter.location.city}, ${inter.location.region}`, 
                  {v:inter.product.variant_id,h:inter.product.handle}, 
                  `${inter_time_hours}:${inter_time_min}`
              ]
          }
        })

        console.log("Mapped FOMO request",interactions)

        // Filter by environment (development,main|"")
        const environment = document.getElementById('purchase-message').parentElement.getAttribute('data-env');
        const interactionsByEnv = interactions.filter( inter => inter.env == environment )

        console.log("FOMO request by Environment",interactionsByEnv)

        // Remove interactions which have the current product
        const product_id = document.getElementById('toast-templates').getAttribute('data-product-id')
        const interactionsWithoutThisProduct = interactionsByEnv.filter( inter => inter.id != product_id )

        //console.log("FOMO request without this product",interactionsWithoutThisProduct)

        // Randomize the interactions
        function randomize(min, max) {
          return Math.floor(Math.random() * (max - min) + min);
        }
        interactionsWithoutThisProduct.sort( () => randomize(-1,2) || randomize(-1,2) )

        console.log("FOMO request without this product &  randomized",interactionsWithoutThisProduct)

        // Creating a set and reverting it back to an array removes duplicates
        fomo_setupToats ( interactionsWithoutThisProduct )
      }
    );

}
document.addEventListener("DOMContentLoaded", initToasts )

// Make function available globally
window.showToast = showToast;